// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ie-0";
export var optionCard = "_ie-1";